module.exports = __webpack_public_path__ + "static/img/access-for-all__large.db6de38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/aside/access-for-all__large.jpg
// module id = 3Hgi
// module chunks = 1